import { apiClient } from './client';

/**
 * 「외부」 일정 이동시간 — GET /calendar/events/:id/travel-time (2026-10-13).
 *
 * ⚠ `api/calendar.ts` 는 여러 세션이 함께 고치는 파일이라 이 하나는 새 파일에 둔다.
 * 서버는 셀 수 없을 때(키 없음·카카오 실패·장소를 못 찾음) **200 + available:false** 를 준다 —
 * 화면은 그때 이동시간 칸을 숨기고 종전 장소 지도를 그린다(오류 알림 없음).
 */
export type TravelOriginKind = 'worksite' | 'head_office' | 'company';

export interface TravelTimeAvailable {
  available: true;
  origin: { lat: number; lng: number; kind: TravelOriginKind; name: string };
  /**
   * `matchedBy:'keyword'` 면 장소 «이름»으로 찾은 곳이다(2026-10-13) — 화면은 `name`·`address` 를 보여
   * 사람이 맞는 곳인지 보게 한다. 주소로 찾았으면 이름·주소가 없다.
   */
  destination: { lat: number; lng: number; matchedBy?: 'address' | 'keyword'; name?: string; address?: string };
  /** 길이 없으면(너무 가깝다 등) null. path 는 [lat, lng] 쌍. */
  driving: { distanceMeters: number; durationSeconds: number; path: Array<[number, number]> } | null;
  /** 어림 — 화면은 「약」을 붙인다. */
  walking: { distanceMeters: number; durationSeconds: number; estimated: true };
}
export interface TravelTimeUnavailable { available: false; reason: string }
export type TravelTimeDto = TravelTimeAvailable | TravelTimeUnavailable;

/** `occurrenceAt`: 반복 일정의 회차를 열었을 때 목록 응답의 그 값 — 회차의 장소·유형으로 센다. 없으면 시리즈 값. */
export async function getEventTravelTime(eventId: string, signal?: AbortSignal, occurrenceAt?: string | null): Promise<TravelTimeDto> {
  const params = occurrenceAt ? { occurrenceAt } : undefined;
  const res = await apiClient.get<TravelTimeDto>(`/calendar/events/${eventId}/travel-time`, { signal, params });
  return res.data;
}
